































import { Component, Prop, Vue } from 'vue-property-decorator';
import {
  Button,
  Input,
  Form,
  FormItem,
  Popover
} from 'element-ui';

import rules from '@/rules/rules';

@Component({
  components: {
    'el-button': Button,
    'el-input': Input,
    'el-form': Form,
    'el-form-item': FormItem,
    'el-popover': Popover
  }
})
export default class Comment extends Vue {
  @Prop({ default: '', type: String }) defaultText!: string;

  formInput = { content: this.defaultText };
  isVisible = false;
  readonly rules = rules;

  $refs!: {
    commentForm: HTMLFormElement;
  };

  reset() {
    this.$refs.commentForm.resetFields();
    this.isVisible = false;
  }

  submit() {
    this.$refs.commentForm.validate(async(valid: boolean) => {
      if (!valid) {
        return;
      }
      this.$emit('send', this.formInput.content);
      this.reset();
    });
  }
}
